import script from "./MemberProfileConfPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberProfileConfPage.vue?vue&type=script&setup=true&lang=js"

import "./MemberProfileConfPage.vue?vue&type=style&index=0&id=4c5913e8&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c5913e8"]])

export default __exports__